<form [formGroup]="form" class="teaser-editor">
  @if (!isPreviewMode()) {
    <div class="teaser-editor__field teaser-editor__field--full">
      <label class="teaser-editor__label" for="teaserHeading">
        {{ 'shop-settings.content.teaser-editor.heading' | translate }}
      </label>
      <span class="teaser-editor__hint">
        {{ 'shop-settings.content.teaser-editor.text-hint' | translate }}
      </span>
      <input
        id="teaserHeading"
        class="teaser-editor__input"
        type="text"
        formControlName="heading"
      />
      @if (form.controls.heading.invalid && form.controls.heading.touched) {
        <div class="teaser-editor__error">
          {{ 'shop-settings.content.teaser-editor.errors.invalid-text' | translate }}
        </div>
      }
    </div>
    <div class="teaser-editor__row">
      <div class="teaser-editor__field">
        <label class="teaser-editor__label" for="teaserHeadingAlignment">
          {{ 'shop-settings.content.teaser-editor.text-alignment' | translate }}
        </label>
        <select
          id="teaserHeadingAlignment"
          class="teaser-editor__select"
          formControlName="headingAlignment"
        >
          @for (option of alignmentOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
      <div class="teaser-editor__field">
        <span class="teaser-editor__label">
          {{ 'shop-settings.content.teaser-editor.text-color' | translate }}
        </span>
        <div class="teaser-editor__color-select-wrap">
          <input
            id="teaserHeadingColorPicker"
            class="teaser-editor__color-input"
            type="color"
            formControlName="headingColor"
            aria-label="Heading color picker"
          />
          <input
            id="teaserHeadingColorText"
            class="teaser-editor__color-text"
            type="text"
            formControlName="headingColor"
            aria-label="Heading color value"
          />
        </div>
      </div>
    </div>
    <div class="teaser-editor__field teaser-editor__field--full">
      <label class="teaser-editor__label" for="teaserAdditionalText">
        {{ 'shop-settings.content.teaser-editor.additional-text' | translate }}
      </label>
      <span class="teaser-editor__hint">
        {{ 'shop-settings.content.teaser-editor.text-hint' | translate }}
      </span>
      <input
        id="teaserAdditionalText"
        class="teaser-editor__input"
        type="text"
        formControlName="additionalText"
      />
    </div>
    <div class="teaser-editor__row">
      <div class="teaser-editor__field">
        <label class="teaser-editor__label" for="teaserAdditionalTextAlignment">
          {{ 'shop-settings.content.teaser-editor.text-alignment' | translate }}
        </label>
        <select
          id="teaserAdditionalTextAlignment"
          class="teaser-editor__select"
          formControlName="additionalTextAlignment"
        >
          @for (option of alignmentOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
      <div class="teaser-editor__field">
        <span class="teaser-editor__label">
          {{ 'shop-settings.content.teaser-editor.text-color' | translate }}
        </span>
        <div class="teaser-editor__color-select-wrap">
          <input
            id="teaserAdditionalTextColorPicker"
            class="teaser-editor__color-input"
            type="color"
            formControlName="additionalTextColor"
            aria-label="Additional text color picker"
          />
          <input
            id="teaserAdditionalTextColorText"
            class="teaser-editor__color-text"
            type="text"
            formControlName="additionalTextColor"
            aria-label="Additional text color value"
          />
        </div>
      </div>
    </div>
    <div class="teaser-editor__field teaser-editor__field--full">
      <label class="teaser-editor__label" for="teaserImageUrl">
        {{ 'shop-settings.content.teaser-editor.image' | translate }}
      </label>

      <div class="teaser-editor__input-with-button">
        <input
          id="teaserImageUrl"
          class="teaser-editor__input teaser-editor__input--with-btn"
          type="text"
          formControlName="teaserImageUrl"
          [placeholder]="'shop-settings.content.teaser-editor.image-placeholder' | translate"
        />
        <button type="button" class="teaser-editor__upload-btn" (click)="fileInput.click()">
          {{ 'shop-settings.content.teaser-editor.upload' | translate }}
        </button>

        <input #fileInput type="file" accept="image/*" hidden (change)="onFileSelected($event)" />
      </div>
    </div>
    <div class="teaser-editor__field teaser-editor__field--full">
      <label class="teaser-editor__label" for="teaserLink">
        {{ 'shop-settings.content.teaser-editor.link' | translate }}
      </label>

      <input id="teaserLink" class="teaser-editor__input" type="text" formControlName="link" />
    </div>
  } @else {
    <div
      class="teaser-editor__preview"
      [style.background-image]="previewImageUrl ? 'url(' + previewImageUrl + ')' : 'none'"
    >
      <div class="teaser-editor__preview-overlay">
        <h3
          class="teaser-editor__preview-heading"
          [class]="previewHeadingAlignmentClass"
          [style.color]="form.controls.headingColor.value"
        >
          {{
            form.controls.heading.value ||
              ('shop-settings.content.teaser-editor.preview-heading' | translate)
          }}
        </h3>
        <p
          class="teaser-editor__preview-text"
          [class]="previewTextAlignmentClass"
          [style.color]="form.controls.additionalTextColor.value"
        >
          {{
            form.controls.additionalText.value ||
              ('shop-settings.content.teaser-editor.preview-additional-text' | translate)
          }}
        </p>
      </div>
    </div>
  }
</form>
